import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-add-edit-question-dialog',
    templateUrl: './add-edit-question-dialog.component.html',
    standalone: false
})
export class AddEditQuestionDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AddEditQuestionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
